module.exports = __webpack_public_path__ + "img/help-ct4.14ea848d.png";